import { c as _c } from "react/compiler-runtime";
// React Imports
import type { Theme } from '@mui/material';
import React from 'react';

// MUI Imports

const SelectIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <i className="material-symbols-arrow-drop-down-rounded" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const iconStyles = (theme: Theme) => ({
  userSelect: 'none',
  display: 'inline-block',
  fill: 'currentColor',
  flexShrink: 0,
  transition: theme.transitions.create('fill', {
    duration: theme.transitions.duration.shorter
  }),
  height: '24px',
  width: '24px',
  position: 'absolute',
  right: '4px',
  top: 'calc(50% - 12px)',
  pointerEvents: 'none'
});
const select: Theme['components'] = {
  MuiInput: {
    defaultProps: {
      disableUnderline: true
    }
  },
  MuiSelect: {
    defaultProps: {
      size: 'small',
      IconComponent: SelectIcon,
      MenuProps: {
        PaperProps: {
          sx: {
            maxHeight: '40vh',
            overflow: 'auto'
          }
        }
      }
    },
    styleOverrides: {
      root: ({
        ownerState
      }) => ({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        height: ownerState.size === 'small' ? '32px' : ownerState.size === 'large' ? '58px' : '48px',
        ...(ownerState.variant === 'standard' && {
          '&:hover': {
            backgroundColor: 'var(--mui-palette-primary-dark)'
          }
        })
      }),
      select: ({
        theme,
        ownerState
      }) => ({
        '& .MuiTypography-root': {
          height: '24px',
          verticalAlign: 'middle',
          lineHeight: '24px'
        },
        display: 'block',
        ...(ownerState.variant === 'outlined' && {
          minHeight: '24px'
        }),
        ...(ownerState.variant === 'standard' && {
          fontWeight: theme.typography.fontWeightMedium
        }),
        '&[aria-expanded="true"] ~ i, &[aria-expanded="true"] ~ svg': {
          transform: 'rotate(180deg)'
        },
        '& ~ i, & ~ svg': iconStyles(theme as Theme),
        '&:not(aria-label="Without label") ~ .MuiOutlinedInput-notchedOutline > legend > span': {
          paddingInline: '5px'
        },
        '&.MuiSelect-select': {
          padding: '4px 32px 4px 12px',
          alignContent: 'center',
          display: 'flex !important',
          alignItems: 'center',
          height: '100%'
        }
      })
    }
  },
  MuiNativeSelect: {
    styleOverrides: {
      select: ({
        theme
      }) => ({
        lineHeight: theme.typography.subtitle1.lineHeight,
        '& + i, & + svg': iconStyles(theme as Theme)
      })
    }
  }
};
export { select };